import script from "./BitrixAccountAttachForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BitrixAccountAttachForm.vue?vue&type=script&setup=true&lang=js"

import "./BitrixAccountAttachForm.vue?vue&type=style&index=0&id=5d2e940b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d2e940b"]])

export default __exports__